export const INVENTORY_UPSELL_KEY = 'inventoryUpsellKey';
export const INVENTORY_TERMS_ACCEPTED = 'inventoryTermAccepted';
export const SIGN_INVENTORY_CONTRACT_TOKEN_KEY = 'signInventoryContractToken';